<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div :class="[ tab === 'builder' ? 'active' : '' ]" @click="goToBuilder" v-if="entity.id">Builder</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="goToBuilder" v-if="entity.id">
          <a href="#">
            Builder
            <i class="fa fa-check-square-o" v-if="tab === 'builder'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <Builder
          v-if="tab === 'builder'"
          :countries="countries"
          @addLocations="addLocations"
          @removeLocation="removeFromSearch"
          />
        <div v-show="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label class="form-label">Vendor</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Vendor"
                placeHolder="Type to search"
                :initVal="entity.vendor"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectVendor"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label for="vz-nm" class="form-label">Name *</label>
              <input type="text" class="form-control" id="vz-nm" v-model="entity.location.name"/>
            </div>
            <div class="form-group">
              <label for="vz-extId" class="form-label">External ID</label>
              <input type="text" class="form-control" id="vz-extId" v-model="entity.externalId"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div v-if="entity.id">
              <div class="form-group">
                <label class="form-label">Add vendor zone location</label>
                <autocomplete
                  :dataset="locationSearchResults"
                  title="Vendor Zone Location"
                  placeHolder="Type to search"
                  :initVal="vendorZoneLocation"
                  v-on:changing="data => locationSearchText = data"
                  :fnFormatText="displayLocation"
                  :fnSelectValue="displayLocation"
                  v-on:selection-made="selectVendorLocation"
                ></autocomplete>
              </div>
              <vue-table
                v-on:table-delete-request="removeLocation"
                :showDelete="true"
                :allow-select="true"
                :show-select-all="true"
                :tableData="vendorLocations.filter(zone => zone.deleted !== 1 )"
                tableTitle="Vendor Zone Locations"
                :fields="fields"
                :maxItems="maxValue"
                v-on:pages-remaining="loadMore"
                v-on:select-all="removeSelectedLocations"
                ></vue-table>
            </div>
            <div v-else class="mt-20 mb-15">
              <p>Once you have saved the vendor zone, you will be able to add locations</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import VueTable from '../../../helpers/VueTable.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import Builder from './VZBuilder'
  import { createRouteIdHash } from '../../../helpers/RouteHash'
  export default {
    name: 'VendorZone',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      Autocomplete,
      VueTable,
      Builder
    },
    data () {
      return {
        fetching: false,
        fields: [
          { header: 'Location', prop: vendorZone => vendorZone.location ? this.displayLocation(vendorZone.location) : '' }
        ],
        page: 1,
        maxValue: null,
        transformForUpdate: {
          vendor: this.toMinus,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Vendor Zones',
        editEntityScreen: 'Admin - Edit/View Vendor Zone',
        tab: 'main',
        boxes: [],
        entity: {
          id: null,
          externalId: null,
          vendor: null,
          location: {
            id: null,
            name: null,
            category: 'VENDOR_ZONE',
            functionMaritime: 0,
            functionRail: 0,
            functionRoad: 0,
            functionAir: 0
          },
          deleted: null
        },
        vendorLocations: [],
        vendorZoneLocation: null,
        entityName: 'vendor-zone'
      }
    },
    computed: {
      isValid () {
        return this.entity.location != null && this.entity.location.name !== null && this.entity.location.name !== ''
      },
      vendorZoneLocations () {
        return this.$store.getters['admin/vendorZoneLocations']
      },
      vendorZoneLocationsCount () {
        return this.$store.getters['admin/vendorZoneLocationsCount']
      },
      fullyLoaded () {
        return this.vendorLocations.length === this.maxValue
      }
    },
    methods: {
      goToBuilder () {
        this.$router.push({ name: 'Admin - Vendor Zone Builder', params: { id: createRouteIdHash(this.entity.id) } })
      },
      addLocations ({ ids }) {
        console.log(ids)
        if (ids.length > 0) {
          ids.forEach(id => {
            this.selectVendorLocation({ id })
          })
        }
      },
      loadMore () {
        if (!this.fetching && !this.fullyLoaded) {
          this.fetching = true
          this.page++
          this.$store.dispatch('admin/loadMoreVendorZoneLocations', {vendorZoneId: this.entity.id, page: this.page})
            .then(res => {
              this.vendorLocations = this.vendorZoneLocations
            }).catch(err => console.log(err))
            .then(() => {
              this.fetching = false
            })
        }
      },
      preSaveRoutine () {
        return new Promise((resolve, reject) => {
          this.saveRelatedEntity('location', this.entity.location)
          .then(({data}) => {
            this.entity.location = data
            resolve()
          }).catch(err => reject(err))
        })
      },
      refresh () {
        this.vendorLocations = this.vendorZoneLocations
      },
      removeFromSearch ({ id }) {
        const i = this.findLocationInEntityLocationsByIndex(this.vendorLocations, { id })
        console.log(i)
        if (i > -1) {
          let vz = this.vendorLocations[i]
          this.removeLocation({ item: vz })
        }
      },
      removeLocation ({ item, index }) {
        const i = this.findLocationInEntityLocationsByIndex(this.vendorLocations, item.location)
        if (item.id) {
          this.deleteRelatedEntity('vendor-zone-to-location', item.id)
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Vendor Zone Location deleted' })
            this.vendorLocations.splice(i, 1)
          })
          .catch(err => {
            event.$emit('toast', { type: 'error', message: 'Unable to delete Vendor Zone Location; please try again or contact support' })
            console.log(err)
          })
        }
      },
      removeSelectedLocations (items) {
        let count = items.length
        if (count > 0) {
          let n = 0
          items.forEach(({id}) => {
            this.deleteRelatedEntity('vendor-zone-to-location', id)
              .catch(err => {
                console.log(err)
                event.$emit('toast', { type: 'error', message: 'Unable to delete Vendor Zone Locations; please try again or contact support' })
              }).then(() => {
                if (++n === count) {
                  this.refreshVendorLocations(items)
                  event.$emit('loading-off')
                  event.$emit('toast', { type: 'success', message: 'Selected Vendor Zone Locations deleted' })
                }
              })
          })
        }
      },
      refreshVendorLocations (items) {
        items.forEach(({id}) => {
          const i = this.findLocationIndexById(this.vendorLocations, id)
          this.vendorLocations.splice(i, 1)
        })
      },
      selectVendorLocation (l) {
        if (Object.keys(l).length > 0) {
          if (this.findLocationInEntityLocationsByIndex(this.vendorLocations, l) > -1) {
            event.$emit('toast', { type: 'warning', message: 'Vendor Zone already contains selected location' })
          } else {
            this.saveRelatedEntity('vendor-zone-to-location', {
              id: null,
              vendorZone: this.entity.id,
              location: l,
              deleted: 0
            }).then(({data}) => {
              event.$emit('toast', { type: 'success', message: 'Vendor Zone Location added' })
              this.vendorLocations.push(data)
            })
            .catch(err => {
              event.$emit('toast', { type: 'error', message: 'Unable to add Vendor Zone Location; please try again or contact support' })
              console.log(err)
            })
          }
        }
        this.locationSearchText = ''
        this.locationSearchResults = []
        this.$nextTick(() => {
          this.vendorZoneLocation = ''
        })
      },
      findLocationInEntityLocationsByIndex (locationsArr, loc) {
        return locationsArr.findIndex(({location}) => location.id === loc.id)
      },
      findLocationIndexById (locationsArr, vendorZoneLocId) {
        return locationsArr.findIndex(({id}) => id === vendorZoneLocId)
      },
      selectVendor (v) {
        this.entity.vendor = v
        this.partySearchText = ''
        this.partySearchResults = []
      },
      getBaseData () {
        this.entity.location.name = ''
        return {
          id: null,
          externalId: null,
          vendor: null,
          locations: [],
          location: {
            id: null,
            name: '',
            category: 'VENDOR_ZONE',
            functionMaritime: 0,
            functionRail: 0,
            functionRoad: 0,
            functionAir: 0
          },
          deleted: null
        }
      }
    },
    mounted () {
      this.vendorLocations = this.vendorZoneLocations
      this.maxValue = this.vendorZoneLocationsCount
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/VendorZone/VendorZone.vue